import React from 'react';
import { MessageCircle, Phone, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { COMPANY, FAQS } from '../../mock';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../ui/accordion';

export function CTABanner() {
  return (
    <section className="relative my-4">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative overflow-hidden rounded-3xl bg-brand-blue p-10 lg:p-14">
          <div className="absolute inset-0 opacity-20" style={{backgroundImage: 'radial-gradient(circle at 20% 20%, #FF6B00 0%, transparent 40%), radial-gradient(circle at 80% 80%, #13345b 0%, transparent 40%)'}} />
          <div className="absolute -top-10 -right-10 w-72 h-72 rounded-full bg-brand-orange/15 blur-3xl" />
          <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 px-3 py-1.5 rounded-full text-[12px] text-white font-medium mb-4">
                <Sparkles size={13} className="text-brand-orange" /> Limited Summer Slots Open
              </div>
              <h2 className="font-poppins font-bold text-white text-[32px] lg:text-[44px] leading-[1.1]">
                Plan Your Dream <span className="text-brand-orange">Mountain Trip</span> Today
              </h2>
              <p className="text-white/75 mt-4 text-[15px] lg:text-[16px] max-w-xl">Talk to a real human travel designer. Get a custom itinerary on WhatsApp in 5 minutes - no obligation, no spam.</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent('Hi Mountains Chain Travel! 👋\n\nI\'d love to plan a mountain trip with you.\n\nPlease share:\n- Popular tour packages\n- Customizable itineraries\n- Best deals & offers\n\nThank you!')}`} target="_blank" rel="noreferrer">
                <Button className="bg-brand-orange hover:bg-brand-orangeDark text-white h-12 px-6 rounded-xl font-semibold btn-glow w-full">
                  <MessageCircle size={17} className="mr-2" /> WhatsApp Us
                </Button>
              </a>
              <a href={`tel:${COMPANY.phone}`}>
                <Button variant="outline" className="bg-transparent border-white/40 text-white hover:bg-white hover:text-brand-blue h-12 px-6 rounded-xl font-semibold w-full">
                  <Phone size={17} className="mr-2" /> {COMPANY.phone}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  return (
    <section className="max-w-4xl mx-auto px-6 py-20 lg:py-24">
      <div className="text-center mb-10">
        <div className="text-brand-orange text-[13px] font-semibold tracking-[0.18em] uppercase mb-2">FAQ</div>
        <h2 className="font-poppins text-[32px] lg:text-[40px] text-brand-blue leading-[1.1]">Quick answers to <span className="text-brand-orange">your questions</span></h2>
      </div>
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-brand-greyDark">
            <AccordionTrigger className="text-left text-brand-blue font-semibold text-[15px] lg:text-[16px] hover:text-brand-orange hover:no-underline py-5">{f.q}</AccordionTrigger>
            <AccordionContent className="text-brand-blue/70 text-[14.5px] leading-relaxed pb-5">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}

export function PartnersStrip() {
  const partners = [
    'Ministry of Tourism', 'IATA Certified', 'ADTOI', 'ISO 9001:2015', 'Google Verified', 'GST Registered', 'BBB Accredited', 'TripAdvisor Choice'
  ];
  return (
    <section className="bg-brand-grey py-10 border-y border-brand-greyDark">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center text-brand-blue/60 text-[12px] font-semibold tracking-[0.2em] uppercase mb-5">Recognised & Approved By</div>
        <div className="overflow-hidden">
          <div className="flex gap-12 lg:gap-16 animate-marquee whitespace-nowrap items-center" style={{width: 'max-content'}}>
            {[...partners, ...partners].map((p, i) => (
              <div key={i} className="text-brand-blue/55 font-poppins font-semibold text-[15px] lg:text-[17px] tracking-wide">{p}</div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
